import { isEmpty } from '../baseUtils';
import { getCookieWckAuthData } from './auth';

const isSsr = (): boolean => typeof window === 'undefined';
export const setLastKwd = async (keyword: string) => {
  if (isEmpty(keyword)) {
    return;
  }

  const date = new Date();
  // 24시간 저장
  date.setHours(date.getHours() + 24);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('LastKwd', keyword, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('LastKwd', keyword, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// wckLiveMktValue(알림톡수신동의여부) 세팅

export const setCookieWckLiveAlarmValue = async (val: string) => {
  if (isEmpty(val)) {
    return;
  }
  const date = new Date();
  // 24시간 저장
  date.setHours(date.getHours() + 24);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckLiveAlarmValue', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckLiveAlarmValue', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

// wckLiveMktValue(알림톡수신동의여부) 값 조회

export const getCookieWckLiveAlarmValue = async () => {
  let wckLiveAlarmValue = 'N';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckLiveAlarmValue = cookie.get('wckLiveAlarmValue')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckLiveAlarmValue = getCookie('wckLiveAlarmValue') as string;
  }
  if (isEmpty(wckLiveAlarmValue)) {
    wckLiveAlarmValue = 'N';
  }
  return wckLiveAlarmValue;
};

export const deleteWckIssueSearchKeyword = async () => {
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.delete('wckIssueSearchKeyword');
  } else {
    const { deleteCookie } = await import('cookies-next');
    deleteCookie('wckIssueSearchKeyword', {
      path: '/',
      domain: '.wconcept.co.kr',
    });
  }
};

export const setWckIssueSearchKeyword = async (val: string) => {
  if (isEmpty(val)) {
    deleteWckIssueSearchKeyword();
    return;
  }
  const date = new Date();
  // 24시간 저장
  date.setHours(date.getHours() + 24);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckIssueSearchKeyword', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckIssueSearchKeyword', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

export const getCustomAdAgreeYn = async () => {
  let customAdAgreeYn = 'N';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    customAdAgreeYn = cookie.get('customAdAgreeYn')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    customAdAgreeYn = getCookie('customAdAgreeYn') as string;
  }
  return customAdAgreeYn;
};

export const getCookieWckDisplayMktSID = async () => {
  let wckDisplayMktSID = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckDisplayMktSID = cookie.get('wckDisplayMktSID')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckDisplayMktSID = getCookie('wckDisplayMktSID') as string;
  }
  return wckDisplayMktSID;
};

// wckDisplaySid setCookie.

export const setWckDisplaySid = async (sid: string) => {
  if (isEmpty(sid)) {
    return;
  }
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckDisplaySID', sid, {
      path: '/',
      domain: '.wconcept.co.kr',
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckDisplaySID', sid, {
      path: '/',
      domain: '.wconcept.co.kr',
    });
  }
};

// WckAuth의 Grade 정보 조회.
/**
 VVIP : 1
 VIP : 2
 PRIME : 3
 BEST : 4
 FRIEND : 5
 WPEOPLE : 6
 LOGIN : 7 (사용안함)
 LOGOFF : 8
 W_SIGNATURE : 11
 W_VIP : 12
 W_BEST : 13
 W_FRIEND : 14
 */
